import ContractItemCostCenter from 'src/modules/contract-item-cost-center/ContractItemCostCenter.vue'

import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'contract-item-cost-center',
    name: 'ContractItemCostCenter',
    component: ContractItemCostCenter,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
